const portretten = [
  {
    name: 'Voorbeeld Portret',
    description: 'Een uniek 3D-portret, perfect als persoonlijk cadeau of kunstobject.',
    dimensions: '12x8x8cm',
    images: [
      require('../../images/portretten/portretten_1A.png'),
      require('../../images/portretten/portretten_1B.png'),
    ],
    stl: '/products/portretten/voorbeeld-portret.stl',
    contactLink: '/contact?product=Voorbeeld%20Portret',
  },
  // Voeg hier meer portretten toe
];

export default portretten; 